var exports = {
  "fs": "SpaceBackground.module__starfield___SnRLWX",
  "UB": "SpaceBackground.module__starDrift___SnRLWX",
  "hi": "SpaceBackground.module__spaceBackground___SnRLWX" + " " + "SpaceBackground.module__starfield___SnRLWX",
};

module.exports = exports;
